// extracted by mini-css-extract-plugin
module.exports = {"HomeView":"HomeView_HomeView__bilcz","Card":"HomeView_Card__uSO7N"};